document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('.mobile-menu-button');
  const menu = document.querySelector('#MainNavigation');
  if (menuButton && menu) {
    menuButton.addEventListener('click', () => {
      const open = menu.classList.toggle('is-open');
      menuButton.setAttribute('aria-expanded', String(open));
    });
    menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => {
      menu.classList.remove('is-open');
      menuButton.setAttribute('aria-expanded', 'false');
    }));
  }

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.reveal').forEach((element) => observer.observe(element));
  } else {
    document.querySelectorAll('.reveal').forEach((element) => element.classList.add('visible'));
  }

  document.querySelectorAll('[data-client-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-carousel-track]');
    const cards = Array.from(carousel.querySelectorAll('[data-carousel-card]'));
    const previous = carousel.querySelector('[data-carousel-previous]');
    const next = carousel.querySelector('[data-carousel-next]');
    const current = carousel.querySelector('[data-carousel-current]');
    const total = carousel.querySelector('[data-carousel-total]');
    let activeIndex = 0;

    const visibleCards = () => Math.max(1, Math.round(track.clientWidth / (cards[0].offsetWidth + 18)));
    const lastStartIndex = () => Math.max(0, cards.length - visibleCards());

    const updateCurrent = () => {
      const trackLeft = track.getBoundingClientRect().left;
      activeIndex = cards.reduce((closestIndex, card, index) => {
        const currentDistance = Math.abs(card.getBoundingClientRect().left - trackLeft);
        const closestDistance = Math.abs(cards[closestIndex].getBoundingClientRect().left - trackLeft);
        return currentDistance < closestDistance ? index : closestIndex;
      }, 0);
      activeIndex = Math.min(activeIndex, lastStartIndex());
      current.textContent = String(activeIndex + 1).padStart(2, '0');
      total.textContent = String(lastStartIndex() + 1).padStart(2, '0');
    };

    const showCard = (index) => {
      const slideCount = lastStartIndex() + 1;
      activeIndex = (index + slideCount) % slideCount;
      cards[activeIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      current.textContent = String(activeIndex + 1).padStart(2, '0');
      total.textContent = String(slideCount).padStart(2, '0');
    };

    previous.addEventListener('click', () => showCard(activeIndex - 1));
    next.addEventListener('click', () => showCard(activeIndex + 1));
    track.addEventListener('scroll', updateCurrent, { passive: true });
    window.addEventListener('resize', updateCurrent, { passive: true });

    cards.forEach((card) => {
      const video = card.querySelector('[data-project-preview]');
      if (!video) return;
      const playPreview = () => video.play().catch(() => {});
      const stopPreview = () => {
        video.pause();
        video.currentTime = 0;
      };
      card.addEventListener('mouseenter', playPreview);
      card.addEventListener('mouseleave', stopPreview);
      card.addEventListener('focusin', playPreview);
      card.addEventListener('focusout', stopPreview);
    });

    if ('IntersectionObserver' in window && window.matchMedia('(max-width: 520px)').matches) {
      const previewObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const video = entry.target.querySelector('[data-project-preview]');
          if (!video) return;
          if (entry.isIntersecting) video.play().catch(() => {});
          else {
            video.pause();
            video.currentTime = 0;
          }
        });
      }, { root: track, threshold: .72 });
      cards.forEach((card) => previewObserver.observe(card));
    }
  });
});
